var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C7.91531 0 5.8125 2.0187 5.8125 4.5V6.3H4.875C3.84094 6.3 3 7.1073 3 8.1V16.2C3 17.1927 3.84094 18 4.875 18H16.125C17.1591 18 18 17.1927 18 16.2V8.1C18 7.1073 17.1591 6.3 16.125 6.3H15.1875V4.5C15.1875 2.0187 13.0847 0 10.5 0ZM7.6875 4.5C7.6875 3.0114 8.94938 1.8 10.5 1.8C12.0506 1.8 13.3125 3.0114 13.3125 4.5V6.3H7.6875V4.5ZM16.1269 16.2H11.4375V14.1498C11.9953 13.8375 12.375 13.2633 12.375 12.6C12.375 11.6073 11.5341 10.8 10.5 10.8C9.46594 10.8 8.625 11.6073 8.625 12.6C8.625 13.2624 9.00469 13.8375 9.5625 14.1498V16.2H4.875V8.1H16.125L16.1269 16.2Z",
    fill: "#919EAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockUnlock);
export default __webpack_public_path__ + "static/media/LockUnlock.996f8faf373fd01122c5921ab03e217a.svg";
export { ForwardRef as ReactComponent };